export const canViewUserIntegrations = () => true;
